export default {
    message: {
      ConnectWallet: 'Connect Wallet',
      Defi: 'Defi mining Liquidity',
      Reward: 'Reward',
      ReceiveVoucher: 'Receive Voucher',
      MiningPool: 'Mining Pool',
      Account: 'Account',
      PoolData: "Pool data",
      TotalOutput: "Total output",
      ValidNode: "Valid node",
      Participant: "Participant",
      UserRevenue: "User Revenue",
      Mining: "Mining",
      LiquidityMiningIncome: "Liquidity mining income",
      UserOutput: "User Output",
      Address: "Address",
      Quantity: "Quantity",
      HelpCenter: "Help center",
      HelpCenter2: "Hope it helps you",
      Question1: "What is node mining?",
      Question2: "Where are the mining earnings from?",
      Question3: "How do i need to join？",
      Question4: "How do i withdraw money",
      Question5: "What is the yield percentage rate?",
      Question6: "What are the extra gains?",
      Question7: "How to contact you?",
      Answer1: "USDT stored in their own wallets, 0 risk, the new blockchain data management and computing model, to boost DEFI ecology. Via the total value of each user node production, liquidity node mining without any reservation and pre-mining and incremental behavior, all ETH users to provide on-chain liquidity, all this will be automatically locked through the smart contract node execution revenue. Currently, you can participate through any wallet, to Miners new generation node mining to take, upon the end of the total revenue obtained through liquidity node mining, through the USDT tokens divide each user's centralized wallet.",
      Answer2: "Once a user participates in mining, liquidity node mining will be activated and the total amount generated by daily node mining will end in 24 hours, with each user acquiring mining data from the Minres new generation liquidity node pool for computing revenue. The daily settlement is6 times, 1 settlement every 4 hours, and the mining revenue is calculated by the percentage of wallet tokens of the liquid node pool users. The mining proceeds will be released to the user's centralised wallet upon successful community submission. The total amount of mobility node mining is accounted for by the ratio of the total amount of the user's wallet tokens. The more tokens you have in the mobility pool, the more tokens you will acquire from mining.",
      Answer3: "Participating in non-destructive and non-guaranteed liquidity mining requires paying ETH or TRX miner fees to receive replacement gold coupons, and the ETH wallet or TRX wallet address only needs to be applied once. Automatically open mining permission after success",
      Answer4: "You can convert the currency generated every day into USDT, and then initiate a withdrawal. USDT withdrawals will be automatically sent to the wallet address you added to the node, other addresses are not supported",
      Answer5: "There is no profit below 100USDT.",
      Answer6: "When you have enough mining per day and keep it for enough time continuously, the mining pool will have a lot of rewards. For more details, please contact online customer service.",
      Answer7: "Please send an email to us, we will reply to you as soon as we receive the email：",
      Yield: " Yield ",
      AuditReport: "Audit report",
      AuditReport2: "We have a secure audit report",
      Partner: "Partner",
      Partner2: "Our business partner",
      MyAccount: "My account",
      ReceiveDescription: "Receive description",
      Description: " You need to pay a miner's fee to receive the voucher, please make sure that your wallet has enough ETH as the miner's fee",
      Receive: "Receive",
      TotalOutput: "Total output",
      IncomeBalance: "Income balance",
      Exchangeable: "Exchangeable",
      Exchange: "Exchange",
      RedeemAll: "Redeem all",
      Price: "Price",
      Withdraw: "Withdraw",
      WithdrawalAll: 'Withdraw all',
      TotalBalance: "Total balance",
      Confirm: "Confirm",
      Tip1: "Convert the ETH coins you dug into USDT, starting at 0.1ETH",
      Tip2: "USDT withdrawals will be sent to your USDT wallet address within 24 hours, and withdrawals can only be made once a day, starting at {min}USDT, Each miner fee is {fee}USDT",
      Record: "Record",
      Time: "Time",
      Status: "Status",
      Type: "Type",
      Output: "Output",
      Succeed: "Succeed",
      Fail: "Fail",
      Withdrawing: "Withdrawing",
      Withdrawing2: "Withdrawal application submitted",
      NOETH: "No redeemable ETH",
      NOETH2: "Not enough convertible ETH",
      ExchangeSuc: 'Exchange successfully',
      MinWithdrawCount: 'The minimum withdrawal amount is',
      Submitting: 'Submitting...',
      ApproveTip: 'Please receive voucher first',
      Approving: 'Authorizing...'
    }
}